import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { API } from "../../shared/apiRoutes";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { getDisplayValue, updateRes } from "../../components/settings/displaySettings/displaySettigModule";

interface commonType {
    loading: boolean,
    error: string,
}

export interface updateDisplay { isUseMyDeviceSettings: boolean | undefined, screenMode: string | undefined, isLockScreenInactive: boolean | undefined, timeValue: string | undefined, timeUnit: string, isCustom: boolean, isLockScreenAfterSale: boolean | undefined, isUseCameraToScanBarcode: boolean | undefined }

interface IntialValueProps {
    loading: boolean,
    error: string,
    getDisplayData: commonType & { value: getDisplayValue | null }
    updateDisplay: commonType & { value: updateRes | null }
    screenMode: string,
    // deviceMode: any
}

const initialState: IntialValueProps = {
    loading: true,
    error: '',
    getDisplayData: { value: null, loading: true, error: "" },
    updateDisplay: { value: null, loading: true, error: "" },
    screenMode: "",
    // deviceMode: ""
}

export const getDisplayData = createAsyncThunk("display/getDisplayData", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getDisplayData, { storeId: storeId });
    return HttpRoutingService.getMethod<getDisplayValue>(url);
})

export const updateDisplay = createAsyncThunk("display/updateDisplay", ({ storeId, data }: { storeId: number, data: updateDisplay }) => {
    const url = HttpRoutingService.replaceUrl(API.getDisplayData, { storeId: storeId });
    return HttpRoutingService.putMethod<updateRes>(url, data, null, "v2/");
})

export const displaySlice = createSlice({
    name: "display",
    initialState,
    reducers: {
        setScreenMode: (state, action: PayloadAction<string>) => {
            state.screenMode = action.payload
        },
        // setDeviceMode: (state, action: PayloadAction<string>) => {
        //     state.screenMode = action.payload
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDisplayData?.pending, (state) => {
                state.getDisplayData.loading = true
            })
            .addCase(getDisplayData?.fulfilled, (state, action) => {
                state.getDisplayData.loading = false
                state.getDisplayData.value = action?.payload
            })
            .addCase(getDisplayData?.rejected, (state, action) => {
                state.getDisplayData.loading = false
                state.getDisplayData.error = action?.error?.message as string
            })
            .addCase(updateDisplay?.pending, (state) => {
                state.updateDisplay.loading = true
            })
            .addCase(updateDisplay?.fulfilled, (state, action) => {
                state.updateDisplay.loading = false
                state.updateDisplay.value = action?.payload
            })
            .addCase(updateDisplay?.rejected, (state, action) => {
                state.updateDisplay.loading = false
                state.updateDisplay.error = action?.error?.message as string
            })
    }
})
export const { setScreenMode } = displaySlice?.actions
export default displaySlice?.reducer